<template><div><h1>VUX V2.1.1Rc.7 发布日志</h1>
<h2><a href="/zh-CN/components/datetime.html">Datetime</a></h2>
<ul><li>[enhance] 支持 PC 上鼠标选择 #1039 @michael829</li>
</ul>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[enhance] 支持 PC 上鼠标选择 #1039 @michael829</li>
</ul>
<h2><a href="/zh-CN/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[enhance] 支持 PC 上鼠标选择 #1039 @michael829</li>
<li>[enhance] 支持根据值自定义显示格式</li>
</ul>
<h2><a href="/zh-CN/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] 修复 Android 下按钮点击事件不触发问题 #1044 @tangtaoit</li>
</ul>
<h2><a href="/zh-CN/components/tab.html">Tab</a></h2>
<ul><li>[feature] 支持定义 bar 宽度</li>
<li>[fix] 修复初始化时没有 tab-item 时导致报错 #1038 @liu2010y</li>
</ul>
<h2><a href="/zh-CN/components/x-address.html">XAddress</a></h2>
<ul><li>[enhance] 支持 PC 上鼠标选择 #1039 @michael829</li>
</ul>
<h2><a href="/zh-CN/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] 在 nextTick 后触发 on-change 事件</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.1Rc.7 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.7-215.vue?82e4baac